import { fabric } from 'fabric';
import type Canvas from '../objects/Canvas';

// Brush for drawing pen objects.
class PenBrush extends fabric.PencilBrush {
  canvas: Canvas;

  onMouseDown(pointer, eventData) {
    super.onMouseDown(pointer, eventData);
    this.canvas.controller.actionSetStylusMenu(null);
  }

  onMouseUp(options) {
    super.onMouseUp(options);
    this.canvas.controller.undoManager.completeUndoGroup();
  }
}

export default PenBrush;
